/* eslint-disable max-len */
import { SLUG_SPORTS, SLUG_NEWS, PROMOTION_SLUG, PROMOTION_SLUG_BY_TYPE, INSTRUCTION_SLUGS } from '~/constants'
import { SLUG_CATEGORY_NEWS } from '~/resources/news'

type Meta = Record<string, string | Record<string, string>>

const getDepositMetaTitle = (brandName: string): Meta => {
  const metaTitle = `${brandName} - Nhà cái uy tín hàng đầu | Nạp tiền`
  return {
    deposit: metaTitle,
    'deposit-ibanking': metaTitle,
    'deposit-phone_card': metaTitle,
    'deposit-momo': metaTitle,
    'deposit-crypto': metaTitle
  }
}
const getWithdrawMetaTitle = (brandName: string): Meta => {
  const metaTitle = `${brandName} - Nhà cái uy tín hàng đầu | Rút tiền`
  return {
    withdraw: metaTitle,
    'withdraw-ibanking': metaTitle,
    'withdraw-phone_card': metaTitle
  }
}
export const META_TITLES = (
  brandName: string,
  indirectBrandName: string,
  indirectBrand2Name: string
): Meta & { default: string } => {
  const brandNameCapitalized = StringUtils.capitalizeFirstCharacter(brandName.toLowerCase())
  const indirectBrandNameCapitalized = StringUtils.capitalizeFirstCharacter(indirectBrandName.toLowerCase())
  const indirectBrand2NameCapitalized = StringUtils.capitalizeFirstAndLastCharacter(indirectBrand2Name.toLowerCase())
  
  return {
    index: `${brandName}: Nhà Cái Uy Tín Số 1 - Đại Lý Chính Thức ${indirectBrandNameCapitalized} và ${indirectBrand2NameCapitalized} | Cá Cược An Toàn`,
    'live-casino': 'Casino online uy tín và hiện đại nhất',

    'lobby-game': {
      default: `Game ${brandName} | Rạng danh cổng game online uy tín`,
      'no-hu': 'Nổ hũ tiền tỷ mỗi ngày, thắng to ngày cùng Slot game online',
      'ban-ca': `Bắn cá online | Cổng game săn hũ cực hot tại ${brandName}`,
      'game-bai': 'Game bài đẳng cấp | Đa dạng các trò chơi thể loại bài',
      slots: 'Thắng tiền tỷ mỗi ngày với Slots Game Online',
      'quay-so': `Quay Số | Keno Kiếm tiền tỷ cùng ${brandName}`,
      'cuoc-sieu-toc': `Cược Siêu Tốc | Tham gia quay kiếm tiền tỷ cùng ${brandName}`,
      battle: `Battle | Tham gia quay kiếm tiền tỷ cùng ${brandName}`,
      ingame: `inGame | Cổng trò chơi cá cược đặc sắc tại nhà cái ${brandName}`,
      lode: 'Lô đề | Bất ngờ thành tỷ phú - Dự đoán, soi cầu xsmt, xsmn, xsmb - Lô đề online ba miền',
      other: 'Game nhanh - Cược to - Thắng lớn'
    },

    'the-thao': `Thể thao ${brandNameCapitalized}: Thiên đường cá cược trực tuyến là đây`,
    [SLUG_SPORTS.A_SPORTS]: '',
    [SLUG_SPORTS.C_SPORTS]: '',
    [SLUG_SPORTS.K_SPORTS]: '',

    [SLUG_NEWS.PAGE]: {
      default: 'Tin tức nóng hổi cập nhật liên tục từng ngày, từng giờ',
      [SLUG_CATEGORY_NEWS.ALL]: `Tổng hợp bảng tin tại nhà cái ${brandNameCapitalized} cho thành viên mới`,
      [SLUG_CATEGORY_NEWS.LO_DE_ONLINE]: `Cập nhật lô đề online từng ngày từng giờ trên ${brandNameCapitalized}`,
      [SLUG_CATEGORY_NEWS.SOI_KEO]: `Soi kèo bóng đá tại ${brandNameCapitalized}: Hiểu rõ để thắng cược lớn`,
      [SLUG_CATEGORY_NEWS.TIP_FOOTBALL]: `Mẹo cực hay dành cho anh em đam mê cá cược tại ${brandNameCapitalized}`,
      [SLUG_CATEGORY_NEWS.BETTING_EXPERIENCE]: `Kinh nghiệm cá cược tại ${brandNameCapitalized}: Hiểu để thắng lớn`
    },

    account: {
      ...getDepositMetaTitle(brandName),
      ...getWithdrawMetaTitle(brandName),
      'transfer-money': `${brandName} - Nhà cái uy tín hàng đầu | Chuyển tiền`,
      'transfer-money-main-to-agency': `${brandName} - Nhà cái uy tín hàng đầu | Chuyển tiền`,
      'transfer-money-agency-to-main': `${brandName} - Nhà cái uy tín hàng đầu | Chuyển tiền`,
      'history-transaction': `${brandName} - Nhà cái uy tín hàng đầu | Lịch sử giao dịch`,
      'history-betting': `${brandName} - Nhà cái uy tín hàng đầu | Lịch sử cá cược`,
      information: `${brandName} - Nhà cái uy tín hàng đầu | Thông tin tài khoản`,
      'change-password': `${brandName} - Nhà cái uy tín hàng đầu | Đổi mật khẩu`,
      'information-password': `${brandName} - Nhà cái uy tín hàng đầu | Đổi mật khẩu`,
      refund: `${brandName} - Nhà cái uy tín hàng đầu | Khuyến mãi của bạn`,
      'information-promotion': `${brandName} - Nhà cái uy tín hàng đầu | Khuyến mãi của bạn`,
      'user-bank': `${brandName} - Nhà cái uy tín hàng đầu | Ngân hàng chính chủ`,
      'information-bank': `${brandName} - Nhà cái uy tín hàng đầu | Ngân hàng chính chủ`
    },

    [PROMOTION_SLUG]: {
      [PROMOTION_SLUG_BY_TYPE.WELCOME]: `Khuyến Mãi 100% Tiền Nạp Lần Đầu Tại Nền Tảng Uy Tín ${brandNameCapitalized}`,
      [PROMOTION_SLUG_BY_TYPE.FIRST_50]:
        `Ưu Đãi Siêu Khủng Tại ${brandNameCapitalized}: Thưởng 50% Tiền Khi Nạp Lần 2`,
      [PROMOTION_SLUG_BY_TYPE.COMMISSION]: 'Thỏa Sức Cá Cược Với Hoàn Trả 1.5% Tổng Tiền Đã Cược Hấp Dẫn',
      default: `Khuyến mãi ${brandNameCapitalized}: Nhận quà khủng liên tục từ nhà cái`
    },

    [INSTRUCTION_SLUGS.ABOUT_US]: `Nền Tảng Cá Cược Đỉnh Cao ${brandNameCapitalized}: Uy Tín, An Toàn, Chất Lượng`,
    [INSTRUCTION_SLUGS.HOW_TO_BET]: `Thắng Lớn Với Hướng Dẫn Cá Cược Chi Tiết, Dễ Hiểu Tại ${brandNameCapitalized}`,
    [INSTRUCTION_SLUGS.HOW_TO_CREATE_ACCOUNT]:
      `Hướng Dẫn Tạo Tài Khoản Nhanh Chóng Và An Toàn Tại ${brandNameCapitalized}`,
    [INSTRUCTION_SLUGS.HOW_TO_DEPOSIT]:
      `Hướng Dẫn Nạp Tiền Nhanh Chóng, Chi Tiết, Hiệu Quả Tại ${brandNameCapitalized}`,
    [INSTRUCTION_SLUGS.HOW_TO_WITHDRAW]: `Hướng Dẫn Rút Tiền ${brandNameCapitalized} Chi Tiết, Dễ Hiểu Cho Người Mới`,
    [INSTRUCTION_SLUGS.HOW_TO_TRANSFER]: `An Toàn Cá Cược ${brandNameCapitalized} Với Hướng Dẫn Chuyển Ví Nhanh Chóng`,
    [INSTRUCTION_SLUGS.TRIAL_ACCOUNT]:
      `Cùng cược thủ sử dụng tài khoản dùng thử tại link vào ${indirectBrandNameCapitalized} và ${indirectBrand2NameCapitalized}`,
    [INSTRUCTION_SLUGS.WHAT_IS_BONG88]:
      `Nhà Cái ${indirectBrandNameCapitalized} - Thỏa Sức Chinh Phục Cá Cược Trực Tuyến`,
    [INSTRUCTION_SLUGS.WHAT_IS_BONGK]:
      `Nhà Cái ${indirectBrand2NameCapitalized} - Thỏa Sức Chinh Phục Cá Cược Trực Tuyến`,
    [INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONG88]:
      `${brandNameCapitalized} và ${indirectBrandNameCapitalized}: Hợp tác đôi bên cùng có lợi`,
    [INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONGK]:
      `${brandNameCapitalized} và ${indirectBrand2NameCapitalized}: Hợp tác đôi bên cùng có lợi`,
    [INSTRUCTION_SLUGS.INTERMEDIATE_BETS]: `Cá Cược Trung Gian Không Qua ${brandNameCapitalized} An Toàn Và Tiện Lợi`,
    [INSTRUCTION_SLUGS.IS_REPUTABLE]: `${brandNameCapitalized} - Nhà Cái Cá Cược Đầy Uy Tín, An Toàn Top Đầu Việt Nam`,
    [INSTRUCTION_SLUGS.SUPPORT]: 'Làm thế nào để được hỗ trợ 24/7 khi gặp sự cố khẩn cấp',
    [INSTRUCTION_SLUGS.PRIVACY_POLICY]: `Chính Sách Bảo Mật ${brandNameCapitalized}: Trải Nghiệm Cá Cược Đầy Trọn Vẹn`,

    default: `${brandName}: Nhà Cái Uy Tín Số 1 - Đại Lý Chính Thức ${indirectBrandNameCapitalized} và ${indirectBrand2NameCapitalized} | Cá Cược An Toàn`
  }
}

export const META_DESCRIPTION = (
  brandName: string,
  indirectBrandName: string,
  indirectBrand2Name: string
): Meta & { default: string } => {
  const brandNameCapitalized = StringUtils.capitalizeFirstCharacter(brandName.toLowerCase())
  const indirectBrandNameCapitalized = StringUtils.capitalizeFirstCharacter(indirectBrandName.toLowerCase())
  const indirectBrand2NameCapitalized = StringUtils.capitalizeFirstAndLastCharacter(indirectBrand2Name.toLowerCase())

  return {
    index:
      `Khám phá ${brandName} - nhà cái uy tín hàng đầu và đại lý số 1 của ${indirectBrandNameCapitalized} và ${indirectBrand2NameCapitalized}. Trải nghiệm cá cược đẳng cấp, an toàn với đa dạng sản phẩm và khuyến mãi hấp dẫn. Tham gia ngay!`,

    'live-casino':
      `Sòng bài Casino Online tại ${brandName} có đầy đủ các trò như: Baccarat, Roulette, Blackjack, Long Hổ, Sicbo,...bảo đảm uy tín. Đặt cược càng lớn thắng nổ hũ cực to`,

    'lobby-game': {
      default:
        `Game ${brandName} là cổng trò chơi cá cược đặc sắc với hàng loạt game đổi thưởng nổi bật: game bài, nổ hũ, bắn cá, lô đề, quay hũ, ... Tham gia Game ${brandName} nhận khuyến mãi khủng.`,
      'no-hu':
        `${brandName} cung cấp các trò chơi Slots Nổ hũ trực tuyến, Tham gia ngay để có cơ hội trở thành tỷ phú. Tất cả Slots Nổ Hũ của ${brandName} đều theo chuẩn quốc tế.`,
      'ban-ca':
        `Chinh phục đại dương và rinh kho báu với trò chơi bắn cá. Tại nhà cái ${brandName}, bắn cá online được nâng lên tầm cao mới. Cùng săn kho báu đại dương ngay`,
      'game-bai':
        `Cổng game bài đổi thưởng vang danh với sự đa dạng thể loại trò chơi đánh bài, đồ họa sắc nét, tỷ lệ trả thưởng cao kèm ưu đãi hàng đầu.`,
      slots:
        `${brandName} cung cấp trò chơi Slots game trực tuyến, ai tham gia trò Slots Game đều có cơ hội trở thành tỷ phú. Tất cả Slots Game của 8live đều theo chuẩn quốc tế`,
      'quay-so':
        `Quay số cùng ${brandName}, sảnh trò chơi dựa vào kỹ năng cá cược và may mắn từ con số của bạn chọn. Tham gia quay số trúng ngay tiền khủng.`,
      'cuoc-sieu-toc': `Cược Siêu Tốc | Tham gia quay kiếm tiền tỷ cùng ${brandName}`,
      battle: `Battle | Tham gia quay kiếm tiền tỷ cùng ${brandName}`,
      ingame:
        `Cổng trò chơi cá cược đặc sắc của nhà cái trực tuyến ${brandName}. Đăng ký tài khoản nhận ưu đãi và tham gia đặt cược nhằm đem về những phần thưởng hấp dẫn.`,
      lode: 'Chơi lô đề trực tuyến',
      other: `Các thể loại game hấp dẫn, chơi nhanh - trúng lớn. Chỉ có tại ${brandName}`
    },

    'the-thao':
      `Khám phá và bùng nổ cá cược thể thao trực tuyến tại một trong những nền tảng uy tín top đầu châu Á ${brandNameCapitalized} với kho game đa dạng cùng tỷ lệ thưởng khổng lồ.`,
    [SLUG_SPORTS.A_SPORTS]: '',
    [SLUG_SPORTS.C_SPORTS]: '',
    [SLUG_SPORTS.K_SPORTS]: '',

    [SLUG_NEWS.PAGE]: {
      default:
        'Xem tin tức bóng đá trong nước và quốc tế mới nhất. Tin tức bóng đá, lịch thi đấu, bảng xếp hạng của giải Ngoại Hạng Anh, C1, La LiGa, Đức, Serie A…trong 24h qua',
      [SLUG_CATEGORY_NEWS.ALL]:
        `Cập nhật thông tin bóng đá nhanh chóng và chính xác nhất tại nền tảng cá cược trực tuyến ${brandNameCapitalized} để gia tăng tỷ lệ thắng cược thành công dành cho người chơi.`,
      [SLUG_CATEGORY_NEWS.LO_DE_ONLINE]:
        `Hãy cùng khám phá và tìm hiểu lô đề online tại nền tảng cá cược trực tuyến ${brandNameCapitalized} đầy uy tín và hấp dẫn với đa dạng thể loại xổ số cùng mẹo thắng hấp dẫn.`,
      [SLUG_CATEGORY_NEWS.SOI_KEO]:
        `Cùng nền tảng ${brandNameCapitalized} khám phá và soi kèo bóng đá cực kỳ hiệu quả và hấp dẫn giúp người chơi có những thông tin bổ ích, gia tăng tỷ lệ thắng cược thể thao.`,
      [SLUG_CATEGORY_NEWS.TIP_FOOTBALL]:
        `Chinh phục cá cược bóng đá trực tuyến tại nền tảng cá cược trực tuyến ${brandNameCapitalized} cùng với những tip bóng đá đầy hấp dẫn và hiệu quả giúp người chơi thắng lớn.`,
      [SLUG_CATEGORY_NEWS.BETTING_EXPERIENCE]:
        `Bùng nổ thắng lớn với kinh nghiệm cá cược trực tuyến luôn thắng, siêu hiệu quả dành cho người chơi tại sân chơi cá cược trực tuyến ${brandNameCapitalized} đầy uy tín và hấp dẫn.`
    },

    [PROMOTION_SLUG]: {
      [PROMOTION_SLUG_BY_TYPE.WELCOME]:
        `Nhận thưởng khủng với chương trình khuyến mãi cực kỳ hấp dẫn với thưởng 100% tiền nạp lần đầu dành cho mọi người chơi đam mê cá cược trực tuyến nhà ${brandNameCapitalized}.`,
      [PROMOTION_SLUG_BY_TYPE.FIRST_50]:
        `Thỏa sức đặt cược không lo hết vốn với khuyến mãi khủng thưởng đến 50% tiền nạp lần 2 dành cho mọi người chơi mới tại nền tảng cá cược trực tuyến uy tín ${brandNameCapitalized}.`,
      [PROMOTION_SLUG_BY_TYPE.COMMISSION]:
        `Thỏa sức cá cược tại nền tảng ${brandNameCapitalized} với chương trình khuyến mãi hoàn trả 1.5% cực kỳ hấp dẫn dành cho tất cả người chơi đam mê cá cược trực tuyến tại hệ thống.`,
      default:
        `Khám phá các chương trình khuyến mãi đa dạng và hấp dẫn tại ${brandNameCapitalized}. Tham gia ngay để nhận thưởng lớn và trải nghiệm cá cược trực tuyến đỉnh cao!`
    },

    [INSTRUCTION_SLUGS.ABOUT_US]:
      `${brandNameCapitalized} - Thiên đường cá cược dành cho anh em cược thủ. Đến đây người chơi sẽ được thoải mái tham gia từ môn thể thao vua cho đến các game bài đổi thưởng.`,
    [INSTRUCTION_SLUGS.HOW_TO_BET]:
      `Hướng dẫn đặt cược ${indirectBrandNameCapitalized} và ${indirectBrand2NameCapitalized} - Hành trình kiếm tiền của quý vị bắt đầu từ đây. Hãy cùng chúng tôi tìm hiểu về cách thức cá cược hấp dẫn tại nhà cái nhé!`,
    [INSTRUCTION_SLUGS.HOW_TO_CREATE_ACCOUNT]:
      `Hướng dẫn tạo tài khoản ${brandNameCapitalized} - Hành trình khởi đầu mở ra cơ hội kiếm tiền cực cao từ cá cược. Hãy tận dụng tối đa những gì mình đang có và tạo ra vốn cho mình.`,
    [INSTRUCTION_SLUGS.HOW_TO_DEPOSIT]:
      `Hướng dẫn nạp tiền ${brandNameCapitalized} - Mở cửa cánh cổng đi đến chiến thắng cho anh em. Được thỏa sức tung hoành mà không bị gián đoạn trong quá trình tham gia cá cược.`,
    [INSTRUCTION_SLUGS.HOW_TO_WITHDRAW]:
      'Hướng dẫn rút tiền - Đích đến cho những người chiến thắng. Được hỗ trợ từ nhà cái bạn sẽ rút được số tiền mong muốn không giới hạn số tiền cũng như số lần.',
    [INSTRUCTION_SLUGS.HOW_TO_TRANSFER]:
      `Hướng dẫn chuyển ví tiền cho anh em tham gia cá cược dễ dàng tại ${brandNameCapitalized}. Từ đó giúp cho trải nghiệm của người chơi được trọn vẹn và thoải mái hơn rất nhiều lần.`,
    [INSTRUCTION_SLUGS.TRIAL_ACCOUNT]:
      `Tài khoản dùng thử ${indirectBrandNameCapitalized} và ${indirectBrand2NameCapitalized} - Không đâu bằng nơi đây, bạn có thể thoải mái cá cược mà không lo lắng về vốn và thua lỗ, hãy để chúng tôi đồng hành cùng bạn.`,
    [INSTRUCTION_SLUGS.WHAT_IS_BONG88]:
      `${indirectBrandNameCapitalized} - Nơi tung hoành thoả sức cho anh em yêu thích cá cược. Tại đây người chơi sẽ không thể cưỡng lại được sức hút từ các trò chơi cá cược của nhà cái.`,
    [INSTRUCTION_SLUGS.WHAT_IS_BONGK]:
      `${indirectBrand2NameCapitalized} - Nơi tung hoành thoả sức cho anh em yêu thích cá cược. Tại đây người chơi sẽ không thể cưỡng lại được sức hút từ các trò chơi cá cược của nhà cái.`,
    [INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONG88]:
      `Trải nghiệm cá cược trọn vẹn và an toàn khi hiểu rõ mối quan hệ giữa ${brandNameCapitalized} và ${indirectBrandNameCapitalized} - nơi mang đến cho bạn những trải nghiệm cá cược thể thao hấp dẫn, uy tín.`,
    [INSTRUCTION_SLUGS.RELATIONSHIP_WITH_BONGK]:
      `Trải nghiệm cá cược trọn vẹn và an toàn khi hiểu rõ mối quan hệ giữa ${brandNameCapitalized} và ${indirectBrand2NameCapitalized} - nơi mang đến cho bạn những trải nghiệm cá cược thể thao hấp dẫn, uy tín.`,
    [INSTRUCTION_SLUGS.INTERMEDIATE_BETS]:
      `Cá cược trung gian ${brandNameCapitalized} - Chắc hẳn không quá xa lạ đối với người chơi lâu năm, nhưng với các cược thủ mới thì sao? Hãy để chúng tôi giải thích rõ cho bạn nhé!`,
    [INSTRUCTION_SLUGS.IS_REPUTABLE]:
      `${brandNameCapitalized} có uy tín không anh em? Khỏi phải nói chỉ cần nhìn hành động thì các thành viên sẽ nhận ra quy mô của nhà cái như thế nào để anh em an tâm đặt cược.`,
    [INSTRUCTION_SLUGS.SUPPORT]:
      `Hỗ trợ 24/7 - ${brandNameCapitalized} luôn đồng hành cùng quý vị trên mọi hành trình cá cược và giúp đỡ khi khách hàng có những thắc mắc về tất cả mọi vấn đề gặp phải.`,
    [INSTRUCTION_SLUGS.PRIVACY_POLICY]:
      `Chính sách bảo mật ${brandNameCapitalized} - Có những điều mà ${brandNameCapitalized} luôn âm thầm làm cho bạn ngay cả khi bạn đang không truy cập vào account của mình. Hãy đến và trải nghiệm!`,

    default:
      `Khám phá ${brandName} - nhà cái uy tín hàng đầu và đại lý số 1 của ${indirectBrandNameCapitalized} và ${indirectBrand2NameCapitalized}. Trải nghiệm cá cược đẳng cấp, an toàn với đa dạng sản phẩm và khuyến mãi hấp dẫn. Tham gia ngay!`
  }
}
